<template>
  <div v-if="typingAgents">
    <div v-for="typing of typingAgents" v-bind:key="typing.id">
      <TypingAgent v-bind:typing="typing" />
    </div>
  </div>
</template>


<script>
import TypingAgent from './TypingAgent.vue'
import { useAgentIsTypingStore } from '@/stores/agentIsTyping';


export default {
  name: 'TypingAgents',
  props: ['conversationId'],
  emits: [],
  components: {
    TypingAgent,
  },
  setup() {
    let agentIsTypingStore = useAgentIsTypingStore();
    return { agentIsTypingStore };
  },
  methods: {

  },
  computed: {
    typingAgents() {
      return this.agentIsTypingStore.findByConversation(this.conversationId, this.$root.currentAgent.id);
    },
  },
}
</script>
